var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.084.25a.473.473 0 0 1 .834 0l8.028 15.059a.47.47 0 0 1-.417.691H.473a.47.47 0 0 1-.417-.691ZM8.5 1.473 1.258 15.059h14.485L8.5 1.473ZM9 12.5v1H8v-1h1Zm0-7v6H8v-6h1Z",
    fill: "#FFB600",
    fillRule: "nonzero"
  })));
};
export default SvgError;